



































import Services from '@/services';

import Errors from '@/utils/Errors';

import Modal from '@/components/mixins/Modal';

export default Modal.extend({
    data: () => ({
        animations: Services.$ui.animationsEnabled,
        errorReporting: Services.$app.isErrorReportingEnabled,
    }),
    watch: {
        animations(enabled: boolean) { this.$ui.setAnimationsEnabled(enabled); },
        errorReporting(enabled: boolean) { Errors.setReportingEnabled(enabled); },
    },
});
